import axios from 'axios'
import { Message } from 'element-ui'

const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API || (process.env.NODE_ENV === 'development' ? 'http://localhost:8109/api' : 'https://qingquan.rwan.org.cn/api'),
  timeout: 15000
})

service.interceptors.request.use(config => {
  const token = localStorage.getItem('xjb_admin_token') || 'demo-admin-token'
  config.headers.Authorization = `Bearer ${token}`
  return config
})

service.interceptors.response.use(response => {
  const res = response.data
  if (res && res.code && res.code !== 200) {
    Message.error(res.message || '请求失败')
    return Promise.reject(res)
  }
  return res.data !== undefined ? res.data : res
}, error => {
  const msg = error.response
    ? `请求失败 (${error.response.status})`
    : '无法连接后端服务，请确认后端已启动（端口 8109）'
  Message.error(msg)
  return Promise.reject(error)
})

export default service
